import type { TrailDefinition } from './types'
import { sparkles } from './sparkles'
import { glow } from './glow'
import { smoke } from './smoke'
import { embers } from './embers'
import { bubbles } from './bubbles'
import { rainbow } from './rainbow'
import { magic } from './magic'
import { neon } from './neon'
import { hearts } from './hearts'
import { lightning } from './lightning'

export const trails: Record<string, TrailDefinition> = {
  sparkles,
  glow,
  smoke,
  embers,
  bubbles,
  rainbow,
  magic,
  neon,
  hearts,
  lightning
}

export const trailOptions = [
  { label: 'None', value: 'none' },
  { label: 'Sparkles', value: 'sparkles' },
  { label: 'Glow', value: 'glow' },
  { label: 'Smoke', value: 'smoke' },
  { label: 'Embers', value: 'embers' },
  { label: 'Bubbles', value: 'bubbles' },
  { label: 'Rainbow', value: 'rainbow' },
  { label: 'Magic', value: 'magic' },
  { label: 'Neon', value: 'neon' },
  { label: 'Hearts', value: 'hearts' },
  { label: 'Lightning', value: 'lightning' }
]

export function getTrail(id: string): TrailDefinition | undefined {
  return trails[id]
}
